import Box from '@mui/material/Box';

interface Props {
    children: any;
}

const FormInputsSeparator = ({ children }: Props) => (
    <Box
        sx={{
            display: 'grid',
            gap: 2,
            mt: 1,
        }}
    >
        {children}
    </Box>
);

export default FormInputsSeparator;
